<template>
  <div>
    <div>
      <router-link to="/courses">
        <div class="d-flex align-center my-3">
          <v-icon>mdi-arrow-left-thin</v-icon>
          <span class="black--text">Courses</span>
        </div>
      </router-link>
    </div>
    <div class="d-flex justify-space-between">
      <div class="heading-1 mb-9">[name_Course]</div>
      <div>
        <v-btn
          class="px-4"
          depressed
          color="primary"
          href="http://iba.rootpointers.net/myselfstudy/subjectcourses"
          ><span class="text_style">Course Preview</span></v-btn
        >
      </div>
    </div>
    <div class="my-14">
      <v-row>
        <v-row>
          <v-col cols="2"> <span class="span1"> Permission</span></v-col>
          <v-col cols="10"
            ><v-chip class="mr-1">Starter</v-chip
            ><v-chip class="mr-1">Practicing</v-chip
            ><v-chip class="mr-1">Instructor</v-chip></v-col
          >
        </v-row>

        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="4"> <span class="span1"> Display Order</span></v-col>
            <v-col cols="8"> <b> #</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> CEUs</span></v-col>
            <v-col cols="8"> <b> 16</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Visibility</span></v-col>
            <v-col cols="8"> <b> Publish</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Level</span></v-col>
            <v-col cols="8"> <b> Beginner</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Price</span></v-col>
            <v-col cols="8"> <b> USD 350.00</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Total Handouts</span></v-col>
            <v-col cols="8"> <b>#</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1">Royalty Payouts</span></v-col>
            <v-col cols="8">
              <span class="primary--text" style="cursor: pointer"
                >See Instructors</span
              ></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1">Livestream</span></v-col>
            <v-col cols="8"> <b> YES/NO</b></v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="4">
              <span class="span1"> Free with account creation</span></v-col
            >
            <v-col cols="8"> <b> YES/NO</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="span1">Expires 1 year from purchase</span></v-col
            >
            <v-col cols="8"> <b> YES/NO</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Total Parts</span></v-col>
            <v-col cols="8"> <b>#</b></v-col>
          </v-row>

          <v-row>
            <v-col cols="4"> <span class="span1"> Category</span></v-col>
            <v-col cols="8"> <b> BodyTalk Courses</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="span1"> Course Translator</span></v-col
            >
            <v-col cols="8"> <b> Robin</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="span1"> Course Instructors</span></v-col
            >
            <v-col cols="8"> <span> <b> Sherry Gilbert </b></span></v-col>
          </v-row>

          <v-row>
            <v-col cols="4"> <span class="span1"> Language</span></v-col>
            <v-col cols="8"> <b> English</b></v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <!------------------image section--------------------------------->
    <div>
      <div class="span1 mb-4">Main image</div>
      <div class="d-flex">
        <v-card flat>
          <v-img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUDH83f7IQeBd533wGmks0QtMlPkzOeSeXtw&usqp=CAU"
            class="mr-4"
            max-width="170"
          ></v-img>
        </v-card>
      </div>
    </div>

    <v-divider class="divider"></v-divider>
  </div>
</template>

<script>
export default {
  name: "PreviewNewParamaCourseComponent",

  data() {
    return {
      AddSeminarDialog: false,
      SuccessSeminarModel: false,
      relatedContentArray: [
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
      ],
    };
  },
  methods: {
    CloseSeminar() {
      this.AddSeminarDialog = false;
      this.SuccessSeminarModel = true;
    },
  },
};
</script>

<style scoped>
.span1 {
  font-size: 14px;
  color: rgba(34, 34, 34, 0.7);
}
.heading1 {
  font-size: 24px;
  font-weight: 500;
}
</style>
